export const HISTORICAL_PREFILL_MESSAGE =
  'Передзаповнене значення. Натисніть або змініть поле, щоб підтвердити його.';

export const HISTORICAL_PREFILL_ERROR_TYPE = 'historicalPrefill';
